module.exports = __webpack_public_path__ + "img/30f9.83637c78.jpg";